import request from 'src/network';
import { Session } from '../types/Session';
import sessionActions from 'src/types/SessionActions';

const apiPathSession = '/api/content/v1/session?type=ai_agent';

export function verifySessionService() {
    return request.GET<Session>(apiPathSession);
}

export function logoutService() {
    if (sessionActions.isLoginAs) {
        const mainSession = sessionActions.mainSession;
        sessionActions.clear();
        // if main sessionActions exist set it
        if (mainSession) {
            sessionActions.setToken(mainSession);
            sessionActions.redirectTo('/');
        } else {
            sessionActions.clearAndRedirectTo('/auth/login');
        }
    } else {
        sessionActions.clearAndRedirectTo('/auth/login');
    }
}
